const config = {
  style: 'mapbox://styles/mapbox/light-v10?optimize=true',
  accessToken: window.mapData.key,
  center: [-122.04338708728923, 37.6665203388622],
  lngOffset: 0.001898249349,
  latOffset: 0.003782283578,
  zoom: 9,
  zoomMobile: 8.5,
  zoomClose: 15,
  pitchClose: 60,
  pitch: 0,
  zoomSpeed: 1.8,
  zoomOutSpeed: 2,
  mobileSize: 680
};

export default config;
